// extracted by mini-css-extract-plugin
export default {"createBtn":"AreaList_createBtn__3E-Jf"};